// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    traffic: {
      label: 'Tráfico de la web',
      help: 'Una fila por página y día: visitas y visitantes',
    },
    leads: {
      label: 'Consultas de la web',
      help: 'Una fila por consulta. El spam no entra en este conjunto',
    },
    dates: {
      day: 'Día',
      received: 'Fecha de la consulta',
    },
    metrics: {
      views: 'Páginas vistas',
      sessions: 'Visitas',
      days: 'Días con datos',
      depth: 'Páginas por visita',
      leads: 'Consultas',
      qualified: 'Cualificadas',
      new: 'Sin contestar',
      discarded: 'Descartadas',
      rate: 'Tasa de cualificación',
    },
    dimensions: {
      site: 'Sitio',
      page: 'Página',
      source: 'Canal',
      leadPage: 'Página de origen',
      leadSite: 'Sitio',
      status: 'Estado',
      assignee: 'Quién la lleva',
    },
  },
  ca: {
    traffic: {
      label: 'Trànsit del web',
      help: 'Una fila per pàgina i dia: visites i visitants',
    },
    leads: {
      label: 'Consultes del web',
      help: 'Una fila per consulta. L\'spam no entra en aquest conjunt',
    },
    dates: {
      day: 'Dia',
      received: 'Data de la consulta',
    },
    metrics: {
      views: 'Pàgines vistes',
      sessions: 'Visites',
      days: 'Dies amb dades',
      depth: 'Pàgines per visita',
      leads: 'Consultes',
      qualified: 'Qualificades',
      new: 'Sense contestar',
      discarded: 'Descartades',
      rate: 'Taxa de qualificació',
    },
    dimensions: {
      site: 'Lloc',
      page: 'Pàgina',
      source: 'Canal',
      leadPage: 'Pàgina d\'origen',
      leadSite: 'Lloc',
      status: 'Estat',
      assignee: 'Qui la porta',
    },
  },
  en: {
    traffic: {
      label: 'Website traffic',
      help: 'One row per page per day: views and sessions',
    },
    leads: {
      label: 'Website enquiries',
      help: 'One row per enquiry. Spam is not in this dataset',
    },
    dates: {
      day: 'Day',
      received: 'Received',
    },
    metrics: {
      views: 'Page views',
      sessions: 'Sessions',
      days: 'Days with data',
      depth: 'Pages per visit',
      leads: 'Enquiries',
      qualified: 'Qualified',
      new: 'Unanswered',
      discarded: 'Discarded',
      rate: 'Qualification rate',
    },
    dimensions: {
      site: 'Site',
      page: 'Page',
      source: 'Channel',
      leadPage: 'Page it came from',
      leadSite: 'Site',
      status: 'Status',
      assignee: 'Assigned to',
    },
  },
  fr: {
    traffic: {
      label: 'Trafic du site',
      help: 'Une ligne par page et par jour : vues et visites',
    },
    leads: {
      label: 'Demandes du site',
      help: 'Une ligne par demande. Le spam n\'y figure pas',
    },
    dates: {
      day: 'Jour',
      received: 'Date de la demande',
    },
    metrics: {
      views: 'Pages vues',
      sessions: 'Visites',
      days: 'Jours avec données',
      depth: 'Pages par visite',
      leads: 'Demandes',
      qualified: 'Qualifiées',
      new: 'Sans réponse',
      discarded: 'Écartées',
      rate: 'Taux de qualification',
    },
    dimensions: {
      site: 'Site',
      page: 'Page',
      source: 'Canal',
      leadPage: 'Page d\'origine',
      leadSite: 'Site',
      status: 'Statut',
      assignee: 'Suivi par',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
